module.exports = __webpack_public_path__ + "static/img_pledge_03@2x-9956e6bcd00d9acb27134340f90edb23.png";